import styled from 'styled-components';
import colors from '../../../../constants/colors';

const Wrapper = styled.div`
  padding: 24px 0;
  width: 100%;

  @media screen and (max-width: 992px) {
    margin: 0 auto;
    width: 100%;
    padding: 24px;
  }
`;

const ListWrapper = styled.div`
  margin: 24px 0 16px;
`;

const FilledBlock = styled.div`
  padding: 0 24px;

  @media screen and (max-width: 992px) {
    margin: 0;
    padding: 0px;
    width: 100%;
  }
`;

const UpdateLink = styled.div`
  display: block;
  color: ${colors.main.blue};
  transition: color 0.3s;

  &:hover {
    color: ${colors.main.darkBlue};
  }

  a:focus-visible & {
    outline: 2px solid ${colors.main.blue};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export { Wrapper, FilledBlock, ListWrapper, UpdateLink };
